import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState: {
  country_code: string;
  country_name: string;
  city: string;
  IPv4: string;
} = { country_code: '', country_name: '', city: '', IPv4: '' };

const ipSlice = createSlice({
  name: 'ip',
  initialState,
  reducers: {
    setIpData: (state, action) => {
      return action.payload.data.data;
    },
    reset: () => initialState,
  },
});

export const { setIpData, reset } = ipSlice.actions;

export const getIpData = (state: RootState) => state.ip;

export default ipSlice.reducer;
